/** Synced from TenantProvider so ApiClient can attach X-Tenant-Id without React context. */

let _tenantSlug: string | null = null;

export function setTenantSlugForApi(slug: string | null): void {
  _tenantSlug = slug?.trim() || null;
}

export function getTenantSlugForApi(): string | null {
  return _tenantSlug;
}

export function getTenantHeaders(): Record<string, string> {
  if (!_tenantSlug) {
    return {};
  }
  return { 'X-Tenant-Id': _tenantSlug };
}
